"use client";
import React from "react";

import PropTypes from "prop-types";

import Modal from "src/components/common/responsiveModal";

import Success from "assets/svg/success.svg";

import styles from "./styles.module.css";

const SuccessModal = ({ isOpen, close }) => {
  return (
    <>
      {isOpen && (
        <Modal
          isOpen={isOpen}
          onClose={close}
          size="small"
          className="mobile:!bottom-0 mobile:!h-auto mobile:!top-auto"
        >
          <div className={styles.successModalWrapper}>
            <Success />
            <h2 className={styles.congratText}>Tebrikler!</h2>
            <p className={styles.successText}>
              Bilgileriniz kaydedilmiştir, mail adresinizi ilk bülten gönderimine dahil edeceğiz.
            </p>
          </div>
        </Modal>
      )}
    </>
  );
};

SuccessModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
};

export default SuccessModal;
